// extracted by mini-css-extract-plugin
module.exports = {"item":"IZat","noResults":"IZafd"};